import store from '../'
import _ from 'lodash'

let resource = store.defineResource({
  name: "syncblastAsset",
  relations: {
    hasMany: {
      questions: [
        {
          localField: "questions",
          localKeys: "questionIds"
        },
        {
          localField: "blastQuestionId",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.questions).find({key: "syncblast"}).get("id").value()
          }
        },
        {
          localField: "blastQuikPollId",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.questions).find({key: "syncblast-poll"}).get("id").value()
          }
        }
      ],
      media: [
        {
          localField: "media",
          localKeys: "mediaIds"
        }
      ],
      blastBackgrounds: [
        {
          localField: "backgrounds",
          localKeys: "backgroundIds"
        }
      ]
    },
    hasOne: {
      questions: [
        {
          localField: "blastQuestion",
          localKey: "blastQuestionId"
        },
        {
          localField: "blastQuikPoll",
          localKey: "blastQuikPollId"
        }
      ],
      media: [
        {
          localField: "backdropVideoId",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.media).find({key: "backdrop", type: "video"}).get("id").value()
          }
        },
        {
          localField: "backdropVideo",
          localKey: "backdropVideoId"
        }
      ]
    }
  },
  afterInject (resource, data) {
    // Give Vue's v-for something to use as a key.
    let id = 1
    _.each(_.get(data, 'background.contentModules') || [], (x) => x.id = id++)
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/syncblastAsset.js